import React from 'react';
import {
  Box, Typography, Button, Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Chip, IconButton, useTheme,
  TablePagination,
  Card,
  CardContent
} from '@mui/material';
import { Edit, Delete } from '@mui/icons-material';

interface BreakdownTableProps {
  title: string;
  rows: any[];
  canManage: boolean;
  onAdd: () => void;
  onEdit: (row: any) => void;
  onDelete: (id: number) => void;
  tableMeta: { total: number; size: number; page: number };
  loadQuestions: (page: number, size: number) => void;
}

const BreakdownTable: React.FC<BreakdownTableProps> = ({ title, rows, canManage, onAdd, onEdit, onDelete, tableMeta, loadQuestions }) => {
  const theme = useTheme();

  return (
    <Box sx={{ mt: 3, mr: 2, ml: 2 }}>
      <Card sx={{ backgroundColor: theme.palette.background.paper, borderRadius: 2, mb: 3 }}>
        <CardContent>
      <Box display="flex" justifyContent="space-between" alignItems="center" mb={2}>
        {/* <Typography variant="h6" sx={{ color: theme.palette.text.primary }}>{`${title} (${tableMeta.total})`}</Typography> */}
        {canManage && <Button
          variant="contained"
          sx={{
            background: 'linear-gradient(135deg, #667eea 0%, #4c5fd7 100%)',
            '&:hover': { background: 'linear-gradient(135deg, #4c5fd7 0%, #c2410c 100%)' },
            mt: 1,
          }}
          onClick={onAdd}
        >
          Add New {`${title}`}
        </Button>}
        <TablePagination
        component="div"
        count={tableMeta.total}
        page={tableMeta.page - 1}
        onPageChange={(e, newPage) => loadQuestions(newPage + 1, tableMeta.size)}
        rowsPerPage={tableMeta.size}
        onRowsPerPageChange={(e) => loadQuestions(1, parseInt(e.target.value, 10))}
        rowsPerPageOptions={[5, 10, 15, 20]}
        labelRowsPerPage={`${title} per page`}

      />
      </Box>
      
      <TableContainer component={Paper} sx={{ backgroundColor: theme.palette.background.default }}>
        <Table>
          <TableHead>
            <TableRow sx={{ bgcolor: '#2d3e50' }}>
              <TableCell sx={{ color: theme.palette.text.primary }}>Name</TableCell>
              <TableCell sx={{ color: theme.palette.text.primary }}>Description</TableCell>
              <TableCell sx={{ color: theme.palette.text.primary }}>Sort Order</TableCell>
              <TableCell sx={{ color: theme.palette.text.primary }}>Active</TableCell>
              {canManage && <TableCell sx={{ color: theme.palette.text.primary }} align="center">Actions</TableCell>}
            </TableRow>
          </TableHead>
          <TableBody>
            {rows.map((row) => (
              <TableRow key={row.id}>
                <TableCell sx={{ color: theme.palette.text.primary }}>{row.name}</TableCell>
                <TableCell sx={{ color: theme.palette.text.primary }}>{row.description}</TableCell>
                <TableCell sx={{ color: theme.palette.text.primary }}>{row.sortOrder}</TableCell>
                <TableCell sx={{ color: theme.palette.text.primary }}>
                  {row.isActive ? (
                    <Chip label="Active" size="small" />
                  ) : (
                    <Chip label="Inactive" size="small" />
                  )}
                </TableCell>
                {canManage && <TableCell align="center">
                  <>
                    <IconButton sx={{ color: '#06beb6' }} onClick={() => onEdit(row)}>
                      <Edit />
                    </IconButton>
                    <IconButton sx={{ color: '#ef4444' }} onClick={() => onDelete(row.id)}>
                      <Delete />
                    </IconButton>
                  </>
                </TableCell>}
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
      <TablePagination
        component="div"
        count={tableMeta.total}
        page={tableMeta.page - 1}
        onPageChange={(e, newPage) => loadQuestions(newPage + 1, tableMeta.size)}
        rowsPerPage={tableMeta.size}
        onRowsPerPageChange={(e) => loadQuestions(1, parseInt(e.target.value, 10))}
        rowsPerPageOptions={[5, 10, 15, 20]}
        labelRowsPerPage={`${title} per page`}
      />
      </CardContent>
      </Card>
    </Box>
  );
};

export default BreakdownTable;